import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { DepositKingModalComponent } from '@features/king/modals/deposit-king-modal/deposit-king-modal.component';
import { KingSkinsModalComponent } from '@features/king/modals/king-skins-modal/king-skins-modal.component';

export function provideKingModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'DepositKingModal', component: DepositKingModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'KingSkinsModal', component: KingSkinsModalComponent }, multi: true },
  ];
}
